import styled from "styled-components";

export const FooterSection = styled.footer`
  background:rgb(4, 35, 63);
  padding: 2rem 0;
  color: white;
  position: relative;
`;

export const ImageContainer = styled.div`
  position: absolute;
  right: 120px; /* Ajuste conforme necessário */
  top: 50%;
  transform: translateY(-50%);

  @media (max-width: 768px) {
    position: static;
    transform: none;
    margin-top: 2rem;
    text-align: center;
  }
`;

export const CopyrightText = styled.p`
  font-size: 1em;
  color: white;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.8rem; /* Ajuste o tamanho da fonte para dispositivos móveis */
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const LegalLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  font-size: 0.9rem;

  a {
    color: white;
    text-decoration: underline;
  }
`;
